import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Autocomplete,   RadioButton, Text } from "@shopify/polaris";
import ShopifyCountriesConfig from "../../../../../../../../assets/ShopifyCountries";
import _ from "lodash";
// * api
// import { getShippingCosts } from '@/api/modules/common'

import "../../../../../index.css"
import { reqPostDropshipmanNewShippingInfo } from "../../../../../../../../api";

/**
 * 选择物流方式
 * @param {Boolean} isShow 是否打开弹窗
 * @param {Array} tableData 物流方式列表
 * @param {Object} productInfo 商品详情
 * @param {Function} onClose 关闭回调
 * @param {Function} onConfirm 确认回调
 * @returns
 */
const Shipping = ({id, isShow, tableData, productInfo, onClose, onConfirm,setShippingData,setRuleForm }) => {
  const { t } = useTranslation();
  const [active, setActive] = useState(false); // 弹窗是否显示
  const [searchLoading, setSearchLoading] = useState(false); // 搜索loading
  const [inputValue, setInputValue] = useState(""); // 输入框
  const [shippingList, setShippingList] = useState([]); // 物流方式列表
  const [toCountry, setToCountry] = useState([]); // 选择的国家
  const [countryOptions, setCountryOptions] = useState(ShopifyCountriesConfig); // 所有国家列表
  useEffect(() => {
    setActive(isShow);
    setShippingList(tableData);
    setToCountry([productInfo.shippingToCountry]);
    // 默认选择国家
    if (productInfo.shippingToCountry === "CN") {
      setInputValue("China");
    } else {
      const countryItem = _.find(ShopifyCountriesConfig, (item) => {
        return item.value === productInfo.shippingToCountry;
      });
      if (countryItem) {
        setInputValue(countryItem.label);
      }
    }
    // eslint-disable-next-line
  }, [isShow]);

  // 关闭弹窗
  const closeModal = () => {
    setInputValue("");
    setToCountry([]);
    onClose();
  };
  // 选择物流
  const handleChange = (item) => {
    const list = [...shippingList];
    _.forEach(list, (el) => {
      if (el.code === item.code && el.ShippingMethod === item.ShippingMethod && el.id === item.id && el.weight_id === item.weight_id) {
        el.selected = 1;
      } else {
        el.selected = 0;
      }
    });
    setShippingList(list);
    
  };

  // 确认
  const handleConfirm = useCallback(() => {
    onConfirm(shippingList);
    closeModal();
    // eslint-disable-next-line
  }, [shippingList]);

  // 更新输入框文本
  const changeText = useCallback(
    (value) => {
      setInputValue(value);
      // 输入框为空时
      if (!value) {
        setCountryOptions(ShopifyCountriesConfig);
        return;
      }
      // 输入框有值时
      const list = _.filter(ShopifyCountriesConfig, (item) => {
        return _.includes(_.toLower(item.label), _.toLower(value));
      });
      setCountryOptions(list);
    },
    // eslint-disable-next-line
    [ShopifyCountriesConfig]
  );

  // 选择国家
  const changeSelect = useCallback(
   async (options) => {
      setSearchLoading(true); // loading
      setCountryOptions(ShopifyCountriesConfig); // 如果通过搜索选择国家，选择国家后，国家列表显示所有国家

      // 更新选中的国家
      setToCountry(options);
      setRuleForm((prevValue)=>{
        const param ={...prevValue.variants,shippingToCountry:options[0]}
        const params = {...prevValue,variants:param}
        return params
      })
      // 更新输入框文本
      const list = _.filter(countryOptions, (item) => {
        return _.includes(options, item.value);
      });
      const labels = _.map(list, "label");
      setInputValue(labels[0]);

      // 查询选择国家的物流
      const params = {
        RecordId: id,
        shippingToCountry: options[0],
        sendGoodsCountry: productInfo.sendGoodsCountry,
      };
      const res = await reqPostDropshipmanNewShippingInfo(params)
      if (res && res.code === '200') {
      	setShippingList(res.data)
        setShippingData(res.data)
    //     setShippingList(list);
        onConfirm(res.data);
        setSearchLoading(false)
      }else{
        setTimeout(() => {
          setSearchLoading(false)
        }, 2000);
      }
    },
    // eslint-disable-next-line
    [countryOptions]
  );

  // 页面主体内容
  const pageContent = active ? (
    <Modal
      open={active}
      onClose={closeModal}
      title={t("Shipping Methods")}
      size="large"
      primaryAction={[
        {
          content: t("Done"),
          onAction: handleConfirm,
        },
      ]}
    >
      <Modal.Section>
        <div className="shipping-methods">
           
            <Text  variant="bodyMd" as="span" color="subdued">
              {t(
                "The selected shipping method is displayed in the price table. This is provided by the supplier and based on your country selection and a standard delivery method (eg ePacket)."
              )}
              {t(
                "Note: This is the cost to send an individual item and does not include premium or bulk sending options."
              )}
            </Text>
           

          {/* 选择国家 */}
          <div className="grid grid-cols-24 mt-12">
            <div className="col-span-12">
              <Autocomplete
                listTitle={t("Countries")}
                options={countryOptions}
                selected={toCountry}
                onSelect={(options) => changeSelect(options)}
                textField={
                  <Autocomplete.TextField
                    onChange={changeText}
                    label={t("Ship to")}
                    value={inputValue}
                    suffix={
                      searchLoading && (
                        <img
                          style={{
                            width: "20px",
                            height: "20px",
                            verticalAlign: "middle",
                          }}
                          src="/loading.gif"
                          alt="loading"
                        />
                      )
                    }
                    placeholder={t("Search Country")}
                  />
                }
                emptyState={
                  <div style={{ textAlign: "left" }}>
                     
                      {t("there is no country to select.")}
                     
                  </div>
                }
              />
            </div>
          </div>

          {/* 物流数据 */}
          <div className="my-8">
            {_.isEmpty(shippingList) ? (
              <div>
                {t(
                  "This Supplier/Shipping Company does not deliver to your selected Country/Region."
                )}
              </div>
            ) : (
              <div>
                <Text  variant="bodyMd" as="span" color="subdued">
                  {t(
                    "These are the shipping methods you will be able to select when processing orders."
                  )}
                </Text>
                <table>
                  <thead>
                    <tr>
                      <th>{t("Shipping Method")}</th>
                      <th>{t("Estimated Delivery Time")}</th>
                      <th>{t("Shipping Cost")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {_.map(shippingList, (item, index) => {
                      return (
                        <tr key={index} onClick={() => handleChange(item)}>
                          <td>
                            <RadioButton
                              label={item.ShippingMethod}
                              checked={item.selected}
                              name="shipping_method"
                            />
                          </td>
                          <td>{item.DeliveryTime}</td>
                          <td>
                            US ${item.BeforeConvertCost} {item.currency_code}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </Modal.Section>
    </Modal>
  ) : null;

  return pageContent;
};
export default Shipping;
